import React, { useState, useEffect } from 'react';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductShowcase from './components/ProductShowcase';
import Philosophy from './components/Philosophy';
import Community from './components/Community';
import Footer from './components/Footer';

function App() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <LanguageProvider>
      <div className="App">
        <Header scrollY={scrollY} />
        <Hero />
        <ProductShowcase />
        <Philosophy />
        <Community />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
